import { createFileRoute } from "@tanstack/react-router";
import NotFound from "@/components/NotFound";
import {
  CatalogPage,
  filterByTag,
  resolveTheme,
  useCatalogIndex,
} from "@/modules/Catalog";

// `/themes/{slug}`: every tag a show carries has a page (a series page links
// each of its tags here), whether or not the Genres menu lists it. A tag no
// show carries any more since a link was shared is a 404 — not an empty grid.
export const Route = createFileRoute("/_default/themes/$theme")({
  component: RouteComponent,
});

function RouteComponent() {
  const { theme: slug } = Route.useParams();
  const { themes, shows, loading, error } = useCatalogIndex();
  const theme = resolveTheme(themes, slug);

  if (!loading && !error && !theme) return <NotFound />;

  return (
    <CatalogPage
      // TanStack keeps the component across a param change: keyed, another
      // theme starts from the first batch of covers, not the last one's.
      key={slug}
      kind="theme"
      title={theme?.label}
      shows={theme ? filterByTag(shows, theme.tag) : []}
      loading={loading}
      error={error}
    />
  );
}
